import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';
import { Environment, ProceduraPosMacModel, ProcedureMacchinePostazione } from '../../models/-index';

@Injectable()
export class ProcedureMacchinePostazioneService extends CrudGenericsService<ProcedureMacchinePostazione, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/ProcedureMacchinePostazione`);
    this.base = `${env.apiUrl}/api/ProcedureMacchinePostazione/`;
  }

  public GetProceduraPosMacModel_ByProceduraOrByTagsCod(
    id: number,
    tag_cod: string = ''
  ): Observable<ProceduraPosMacModel[]> {
    const url = this.base + 'GetProceduraPosMacModel_ByProceduraOrByTagsCod?id=' + id + '&cod=' + tag_cod;
    return this.http.get<ProceduraPosMacModel[]>(`${url}`);
  }
}
